var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlankbgIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1516,
    height: 598,
    viewBox: "0 0 1516 598",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 0.5,
    cy: 0.5,
    r: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ad85e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.014,
    y1: 0.108,
    x2: 0.98,
    y2: 0.972,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0.141
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_8054",
    x: 794,
    y: 0,
    width: 722,
    height: 597,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 15,
    dy: 15,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 25,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.051
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-2",
    cx: 0.5,
    cy: 0.5,
    r: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f1bb5c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_8056",
    x: 0,
    y: 1,
    width: 640,
    height: 586,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 15,
    dy: 15,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 25,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.051
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_8054-2",
    x: 794,
    y: 1,
    width: 722,
    height: 597,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 15,
    dy: 15,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 25,
    result: "blur-3"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.051
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-3"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_8078",
    x: 124,
    y: 138,
    width: 1268,
    height: 450,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 15,
    dy: 15,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 25,
    result: "blur-4"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.051
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-4"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_39401",
    "data-name": "Group 39401",
    transform: "translate(60 -3416)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_39036",
    "data-name": "Group 39036",
    transform: "translate(777 3476)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1294",
    "data-name": "Ellipse 1294",
    cx: 294.5,
    cy: 188.5,
    rx: 294.5,
    ry: 188.5,
    transform: "translate(0 59)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -837, -60)",
    filter: "url(#Rectangle_8054)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_8054-3",
    "data-name": "Rectangle 8054",
    transform: "translate(854 60)",
    stroke: "rgba(255,255,255,0.25)",
    strokeWidth: 2,
    fill: "url(#linear-gradient)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 572,
    height: 447,
    rx: 10,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 570,
    height: 445,
    rx: 9,
    fill: "none"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_39158",
    "data-name": "Group 39158",
    transform: "translate(0 3477)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_39369",
    "data-name": "Group 39369"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1298",
    "data-name": "Ellipse 1298",
    cx: 241.5,
    cy: 218,
    rx: 241.5,
    ry: 218,
    fill: "url(#radial-gradient-2)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -60, -61)",
    filter: "url(#Rectangle_8056)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_8056-2",
    "data-name": "Rectangle 8056",
    transform: "translate(60 61)",
    stroke: "rgba(255,255,255,0.25)",
    strokeWidth: 2,
    fill: "url(#linear-gradient)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 490,
    height: 436,
    rx: 10,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 488,
    height: 434,
    rx: 9,
    fill: "none"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_39079",
    "data-name": "Group 39079",
    transform: "translate(777)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1294-2",
    "data-name": "Ellipse 1294",
    cx: 294.5,
    cy: 188.5,
    rx: 294.5,
    ry: 188.5,
    transform: "translate(0 59)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -837, -61)",
    filter: "url(#Rectangle_8054-2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_8054-4",
    "data-name": "Rectangle 8054",
    transform: "translate(854 61)",
    stroke: "rgba(255,255,255,0.25)",
    strokeWidth: 2,
    fill: "url(#linear-gradient)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 572,
    height: 447,
    rx: 10,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 570,
    height: 445,
    rx: 9,
    fill: "none"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -60, -61)",
    filter: "url(#Rectangle_8078)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_8078-2",
    "data-name": "Rectangle 8078",
    transform: "translate(184 198)",
    fill: "#fff",
    stroke: "rgba(255,255,255,0.25)",
    strokeWidth: 2,
    opacity: 0.67
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1118,
    height: 300,
    rx: 10,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 1116,
    height: 298,
    rx: 9,
    fill: "none"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlankbgIcon);
export default __webpack_public_path__ + "static/media/blankbg-icon.bf8937c5e515b6be29d75da4e41746e4.svg";
export { ForwardRef as ReactComponent };